import { PcmpRequestedQueueTable } from '../components/PcmpRequested/PcmpRequestedQueueTable';

export function PcmpRequestedQueuePage() {
  return <PcmpRequestedQueueTable />;
}
